import { MantineThemeOverride } from '../theme.types';

export function createTheme(theme: MantineThemeOverride): MantineThemeOverride {
  return theme;
}
